
import { defineComponent } from "vue";
import MessageNotification from "@/components/MessageNotification.vue";

export default defineComponent({
  name: "MessageNotificationList",
  methods: {
    onMessageClose(messageId: number) {
      this.$store.commit("msg/removeMessage", messageId);
    },
  },
  components: {
    MessageNotification,
  },
});
